<template>
    <button v-if="short" class="btn btn-sm btn-primary d-flex align-items-center justify-content-center float-end"
        @click="showClearedAbsenceModal" v-tooltip
        :title="$trans.get('__JSON__.Add absence')">
        <span class="material-symbols-outlined"> add </span>
    </button>
    <button v-else class="btn btn-primary" @click="showClearedAbsenceModal">
        {{ $trans.get("__JSON__.Add absence") }}
    </button>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="absencemodal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="!absence.id" class="modal-title">{{ $trans.get("__JSON__.Add absence") }}</h5>
                        <h5 v-if="absence.id" class="modal-title">{{ $trans.get("__JSON__.Edit absence") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="errors" class="alert alert-danger" role="alert">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error">
                                    {{ $trans.get("__JSON__." + error) }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6" id="employeeParent" v-if="this.employee_id == undefined">
                                <label for="employee_id">{{ $trans.get("__JSON__.Employee") }}</label>
                                <input type="text" id="employeename" class="form-control" autocomplete="off" />
                                <input type="hidden" v-model="absence.employee_id" id="employee_id" />
                            </div>

                            <div class="mb-3 col-4">
                                <label for="absence_project">{{ $trans.get("__JSON__.Project") }}</label>
                                <select class="form-control" v-model="absence.project_id" id="absence_project_id">
                                    <option
                                        v-if="!((absence.absence_type_id == 7 && oldAbsence.absence_type_id == null) || oldAbsence.absence_type_id == 7)"
                                        value="0" selected>
                                        {{ $trans.get("__JSON__.Choose absence type") }}
                                    </option>
                                    <option v-for="item in filteredAbsenceProjects" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>

                            <!-- <div class="mb-3 col-2 ">
                                <div class="form-row">
                                    <div class="form-group col-2 form-check form-switch">
                                        <label class="form-check-label" for="isSpecial_leave">
                                                {{ $trans.get("__JSON__.Special leave") }}
                                            </label>
                                            <input v-model="isSpecialLeave" class="form-check-input ml-4 mt-3" type="checkbox" id="isSpecial_leave" style="transform: scale(1.8);">
                                    </div>
                                </div>
                            </div> -->

                        </div>

                        <div class="row">
                            <div class="mb-3 col-3" v-if="actualProject?.absence_type_id == 2">
                                <label for="half_day">{{ $trans.get("__JSON__.Vacation days") }}</label>
                                <select class="form-control d-inline" v-model="absence.half_day" id="absence_half_day">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.Whole days") }}
                                    </option>
                                    <option value="1" selected>
                                        {{ $trans.get("__JSON__.Half day") }}
                                    </option>
                                </select>
                            </div>
                            <div class="mb-3 col-3" v-if="actualProject?.absence_type_id == 2">
                                <label for="second_half">&nbsp;</label>
                                <select v-if="absence.half_day" class="form-control d-inline"
                                    v-model="absence.second_half" id="absence_second_half">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.First half of shift") }}
                                    </option>
                                    <option value="1" selected>
                                        {{ $trans.get("__JSON__.Second half of shift") }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-3 col-6" v-if="actualProject?.absence_type_id == 2 && absence.start_at">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <label class="col-12" for="days">{{ $trans.get("__JSON__.Days available")
                                            }}</label>
                                            <input type="text" class="form-control col-8 mr-1" v-model="vacation_days"
                                                id="days" readonly />
                                            <span class="col-2 material-symbols-outlined float-start text-primary"
                                                style="font-size:25px;" v-tooltip
                                                :title="$trans.get('__JSON__.Vacationdays available according to vacation account.')">
                                                help
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row text-left">
                                            <!-- <input type="text" class="form-control col-5 ml-1" v-if="theoretical_vacation_days > vacation_days" v-model="vacation_days"  id="daysallowed" readonly /> -->
                                            <label class="col-12 text-start" for="daysallowed">{{
                                                $trans.get("__JSON__.remaining vacation entitlement") }}</label>
                                            <input type="text" class="form-control col-8 ml-1"
                                                v-model="recalculatedTheoreticalDays" id="daysallowed" readonly />
                                            <span class="col-2 material-symbols-outlined float-start text-primary"
                                                style="font-size:25px;" v-tooltip
                                                :title="$trans.get('__JSON__.Vacationdays entitlement according to time of year, carry over from last year and already taken days.')">
                                                help
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="mb-3 col-6">
                                    <label for="start_at">{{ $trans.get("__JSON__.Start") }}</label>
                                    <input type="date" class="form-control" v-model="absence.start_at" id="start_at" />
                                </div>

                                <div class="mb-3 col-6" v-if="absence.half_day == 0">
                                    <label for="end_at">{{ $trans.get("__JSON__.End") }}</label>
                                    <input type="date" class="form-control" v-model="absence.end_at" id="end_at"
                                        :min="formatDate(absence.start_at)" />
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="mb-3 col-6" v-if="actualProject?.absence_type_id == 2">
                                <label for="absence_type_id">{{ $trans.get("__JSON__.Unpaid vacation") }}</label>
                                <select class="form-control" v-model="absence.unpaid" id="absence_unpaid">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1" selected>
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-3 col-6"
                                v-if="actualProject?.absence_type_id == 2 && employee && employee.flextime == true">
                                <label for="absence_from_flextime">{{ $trans.get("__JSON__.From flextime") }}</label>
                                <select class="form-control" v-model="absence.from_flextime" id="absence_from_flextime">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1" selected>
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-3 col-6"
                                v-if="actualProject?.absence_type_id == 2 && ((absence.needs_second_approval == 1 && absence.team_approved_at != null && hr == 1) || absence.needs_second_approval == 0)">
                                <label for="absence_granted">{{ $trans.get("__JSON__.Vacation status") }}</label>
                                <select class="form-control" v-model="absence.granted" id="absence_granted">
                                    <option value="0" selected>
                                        {{ $trans.get("__JSON__.requested") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.granted") }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-3 col-6" v-if="actualProject?.absence_type_id == 1 && hr == 1">
                                <label for="absence_sick_certificate">{{ $trans.get("__JSON__.Sick note") }}</label>
                                <select class="form-control" v-model="absence.sick_certificate"
                                    id="absence_sick_certificate">
                                    <option value="0" selected>
                                        {{ $trans.get("__JSON__.No sick certificate") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Sick certificate") }}
                                    </option>
                                </select>
                            </div>
                            <div class="mb-3 col-6 d-flex align-items-end"
                                v-if="actualProject?.absence_type_id == 1 && absence.requested_sick_certificate_at != null">
                                <span class="material-symbols-outlined text-danger mb-2"
                                    style="font-size:25px;">
                                    exclamation
                                </span>
                                <span class="material-symbols-outlined text-danger mb-2" style="font-size:25px;"
                                    v-tooltip
                                    :title="$trans.get('__JSON__.A sick certificate is already requested for this absence.')">
                                    prescriptions
                                </span>
                            </div>

                            <div class="mb-3 col-6"
                                v-if="actualProject?.absence_type_id == 2 && this.can('special_leave-add') && absence.unpaid != 1">
                                <label for="absence_special_leave">{{ $trans.get("__JSON__.Special leave") }}</label>
                                <select class="form-control" v-model="absence.special_leave" id="absence_special_leave">
                                    <option value="0" selected>
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-3 col-6">
                                <div class="row mb-2">
                                    <div class="col-3"></div>
                                    <div class="col-9" v-if="actualProject?.absence_type_id == 2 && hr == 1">
                                        {{ possibilityReport }}
                                        <div v-if="!possibilityCheck">
                                            <ul>
                                                <li v-for="week in possibilityFaultyWeeks">
                                                    <a :href="week.href">{{ week.linktext }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 col-6" v-if="absence.special_leave == 1 || absence.proove_required == 1">
                                <label for="absence_proove_received">{{ $trans.get("__JSON__.Proove received")
                                    }}</label>
                                <select class="form-control" v-model="absence.proove_received" :disabled="hr != 1"
                                    id="absence_proove_received">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="comment">{{ $trans.get("__JSON__.comment") }}</label>
                                <input type="text" class="form-control" v-model="absence.comment" id="comment"></input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="!saving" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                        <button v-if="!saving" type="button" class="btn btn-primary" @click="saveAbsence">
                            {{ $trans.get("__JSON__.Save") }}
                        </button>
                        <span v-if="saving">{{ $trans.get("__JSON__.saving") }}...</span>
                    </div>
                    <div class="modal-footer">
                        <history v-if="absence.changes" :changes="absence.changes" :absence-types="absencetypes"
                            :projects="absenceprojects">
                        </history>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { ref, watch } from "vue";

import getEmployees from "../composables/getEmployees";
import { inAllowedTimeframe, spansOverYearChange } from "../checkdate";

export default {
    name: "AddAbsence",
    props: {
        employee_id: String,
        reload: String,
        hr: String,
        short: Boolean,
        selecteddate: String,
    },
    emits: ['saved'],
    setup(props) {
        if (props.employee_id == undefined) {
            const { employees, employees_error, loadEmployees } = getEmployees();
            loadEmployees().then(response => {
                const acemployees = ref([]);
                employees.value.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.value.push(employee);
                    }
                });

                $('#employeename').autocomplete({
                    source: acemployees.value,
                    appendTo: '#employeeParent'
                });
            });

            return { employees };
        } else {
        }
    },
    data() {
        return {
            saving: false,
            absencetypes: null,
            absenceprojects: null,
            errors: null,
            vacation_days: 0,
            theoretical_vacation_days: 0,
            employee: null,
            absence: {
                id: null,
                employee_id: null,
                absence_type_id: null,
                project_id: null,
                start_at: null,
                end_at: null,
                half_day: 0,
                second_half: 0,
                granted: 1,
                from_flextime: 0,
                unpaid: 0,
                special_leave: 0,
                proove_received: 0,
                team_approved_at: null,
                needs_second_approval: 0,
                changes: null
            },
            oldAbsence: {
                id: null,
                employee_id: null,
                absence_type_id: null,
                project_id: null,
                start_at: null,
                end_at: null,
                half_day: 0,
                second_half: 0,
                granted: 1,
                from_flextime: 0,
                unpaid: 0,
                special_leave: 0,
                proove_received: 0,
                team_approved_at: null,
                needs_second_approval: 0,
            },
            possibilityCheck: null,
            possibilityReport: '',
            possibilityFaultyWeeks: [],
            scrollpos: null,
            can_negative_vacation: false,
        };
    },
    computed: {
        actualProject() {
            if (!this.absenceprojects) {
                return null;
            }

            return this.absenceprojects.find(
                (item) => item.id == this.absence.project_id
            );
        },
        autocompleteemployees() {
            //console.log("autocompletearray");
            var acemployees = [];
            if (this.employees != null) {
                this.employees.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.push(employee);
                    }
                });
            }
            return acemployees;
        },
        computedAbsence() {
            return this.absence;
        },
        filteredAbsenceProjects() {
            if (this.absenceprojects && this.absence) {
                if (this.hr != '1' && ((this.absence.absence_type_id == 7 && this.oldAbsence.absence_type_id == null) || this.oldAbsence.absence_type_id == 7)) {
                    return this.absenceprojects.filter((absenceproject) => {
                        return (absenceproject.absence_type_id == 7) || (absenceproject.absence_type_id == 2) || (absenceproject.absence_type_id == 1) || (absenceproject.unexcused == 1);
                        // Urlaub wieder rein auf Anweisung von Julia 31.07.24
                    });
                }
            }

            if (this.absenceprojects) {
                return this.absenceprojects;
            }
            return null;
        },
        recalculatedTheoreticalDays() {
            if (this.theoretical_vacation_days > this.vacation_days) {
                return this.vacation_days;
            }
            return this.theoretical_vacation_days;
        }
    },
    watch: {
        absence: {
            handler: function (newValue, oldValue) {
                if (newValue && newValue.unpaid == 1 && newValue.unpaid != this.oldAbsence.unpaid) {
                    this.absence.from_flextime = 0;
                    this.absence.half_day = 0;
                }

                if (newValue && newValue.from_flextime == 1 && newValue.from_flextime != this.oldAbsence.from_flextime) {
                    this.absence.unpaid = 0;
                }

                if (newValue && newValue.half_day == 1 && newValue.half_day != this.oldAbsence.half_day) {
                    this.absence.unpaid = 0;
                }

                if (newValue && newValue.start_at != this.oldAbsence.start_at) {
                    this.fetchTheoreticalAllowedDaysByStateOfContract(newValue.start_at);
                }
                if (newValue && newValue.end_at != this.oldAbsence.end_at) {
                    this.fetchTheoreticalAllowedDaysByStateOfContract(newValue.end_at);
                }

                if (newValue && newValue.employee_id != this.oldAbsence.employee_id) {
                    this.fetchEmployee();
                }

                if (this.absence.project_id) {
                    const project = this.absenceprojects.find((item) => item.id == this.absence.project_id);
                    if (project) {
                        this.absence.absence_type_id = project.absence_type_id;
                        if (this.absence.absence_type_id != 2) {
                            this.absence.unpaid = project.unpaid;
                        }
                    }
                }

                if (newValue.absence_type_id == 1 || newValue.absence_type_id == 3) {
                    this.absence.half_day = 0;
                }

                if (newValue.absence_type_id != 2) {
                    this.absence.granted = 0;
                }
                this.oldAbsence = JSON.parse(JSON.stringify(newValue));
            },
            deep: true,
        },
    },
    created() {
        this.can_negative_vacation = this.checkPermission('negative-vacation');
        this.fetchData();

        if (this.employee_id != undefined) {
            this.absence.employee_id = parseInt(this.employee_id);
        }

        this.emitter.on('edit-absence', (evt) => {
            this.loadAbsence(evt.id);
            //console.log('load absence event', evt);
        });
    },
    mounted() {
        var self = this;

        $('#employeename').on("autocompleteselect", function (event, ui) {
            $(this).val(ui.item.label);
            self.absence.employee_id = ui.item.value;
            self.fetchEmployee();

            //console.log("EmployeeId_autocomplete: " + self.absence.employee_id);

            return false;
        });


        // $('#absencemodal').on('show.bs.modal', function () {
        //     this.scrollpos = window.scrollY;
        //     $("body").addClass('stopScroll');
        // });

        // $('#absencemodal').on('hide.bs.modal', function () {
        //     $("body").removeClass('stopScroll');
        //     if (this.scrollpos) window.scrollTo(0, this.scrollpos);
        // });

        // $('#absencemodal').on('shown.bs.modal', function () {
        //     $('#absencemodal').trigger('focus')
        // });
    },
    methods: {
        fetchData() {
            this.fetchAbsenceTypes();
            this.fetchAbsenceProjects();
            if (this.absence.employee_id) {
                this.fetchEmployee();
            }
        },
        fetchTheoreticalAllowedDaysByStateOfContract(date) {
            if (date) {
                axios
                    .get("/api/employees/" + this.absence.employee_id + "/projectedvacationentitelementforyear", {
                        params: {
                            start_at: this.formatDate(date)
                        }
                    })
                    .then((resp) => {
                        console.log("theoretical: ", resp.data);
                        this.theoretical_vacation_days = resp.data.days   //Math.round(parseFloat(resp.data.days));
                        this.vacation_days = resp.data.daysleft;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                this.theoretical_vacation_days = 0;
            }
        },
        fetchAbsenceTypes() {
            axios
                .get("/api/absencetypes", {})
                .then((resp) => {
                    //                    console.log(resp.data);
                    this.absencetypes = resp.data.filter(
                        (absencetype) => absencetype.not_manual == false
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchEmployee() {
            axios
                .get("/api/employees/" + this.absence.employee_id, {})
                .then((resp) => {
                    //console.log(resp.data);
                    this.employee = resp.data;
                    $('#employeename').val(this.employee.lastname + ", " + this.employee.forename);

                    this.fetchPossibilityForVacation(this.absence);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchAbsenceProjects() {
            axios
                .get("/api/absenceprojects", {
                    params: {
                        roleProjects: 'true'
                    }
                })
                .then((resp) => {
                    //console.log("AbsenceProjects", resp.data);
                    this.absenceprojects = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async saveAbsence() {
            this.saving = true;
            /**
             * check if it is a vacation and if start and end date confirm to rules
             */
            if (this.absence.half_day == 1) {
                this.absence.end_at = this.absence.start_at;
            }

            if (this.absence.absence_type_id == 2) {
                console.log('vacation check dates');
                if (!inAllowedTimeframe(3, 12, this.absence.start_at, this.absence.end_at)) {
                    console.log('checkdates.js: TimeFrameError');
                    return;
                }
                if (spansOverYearChange(this.absence.start_at, this.absence.end_at)) {
                    console.log('checkdates.js: OverYearChange Error');
                    return false;
                }

            }

            if (this.absence.id != null) {
                console.log('add absencemodal update absence');
                axios
                    .put("/api/absences/" + this.absence.id, this.absence)
                    .then((resp) => {
                        $("#absencemodal").modal("hide");
                        this.clearAbsence();
                        $("#employeename").val('');
                        this.$emit('saved');
                        if (this.reload == 'on') {
                            location.reload();
                        }
                        this.emitter.emit('absence-edited', { 'id': parseInt(this.absence_id) });
                        this.saving = false;
                    })
                    .catch((error) => {
                        this.saving = false;
                        console.log(error.response.data);
                        this.errors = error.response.data.errors;
                    });
            } else {
                console.log('add absencemodal store absence');
                axios
                    .post("/api/absences", this.absence)
                    .then((resp) => {
                        console.log('resp: ', resp);
                        $("#absencemodal").modal("hide");
                        this.clearAbsence();
                        $("#employeename").val('');
                        this.$emit('saved');
                        if (this.reload == 'on') {
                            location.reload();
                        }
                        this.emitter.emit('absence-edited', { 'id': parseInt(this.absence_id) });
                        this.saving = false;
                    })
                    .catch((error) => {
                        this.saving = false;
                        console.log(error.response.data.errors);
                        this.errors = error.response.data.errors;
                    });
            }
        },
        clearAbsence() {
            this.absence = {
                id: null,
                employee_id: null,
                absence_type_id: null,
                project_id: null,
                start_at: null,
                end_at: null,
                half_day: 0,
                second_half: 0,
                granted: 1,
                from_flextime: 0,
                unpaid: 0,
                special_leave: 0,
                proove_received: 0,
                team_approved_at: null,
                needs_second_approval: 0,
                changes: null
            };
            this.errors = null;
            if (this.employee_id != undefined) {
                this.absence.employee_id = parseInt(this.employee_id);
            }

            if (this.selecteddate) {
                this.absence.start_at = this.selecteddate;
                this.absence.end_at = this.selecteddate;
            }
        },
        showClearedAbsenceModal() {
            this.clearAbsence();
            this.showAbsenceModal();
        },
        showAbsenceModal() {
            $("#absencemodal").modal("show");
        },
        loadAbsence(absenceId) {
            axios
                .get("/api/absences/" + absenceId)
                .then((resp) => {
                    //console.log(resp.data);
                    resp.data.start_at = this.formatDate(new Date(resp.data.start_at));
                    resp.data.end_at = this.formatDate(new Date(resp.data.end_at));
                    if (resp.data.team_approved_at) {
                        resp.data.team_approved_at = this.formatDate(new Date(resp.data.team_approved_at));
                    }
                    this.absence = resp.data;

                    if (this.employee) {
                        $('#employeename').val(this.employee.lastname + ", " + this.employee.forename);
                    }

                    this.errors = null;
                    this.showAbsenceModal();

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        formatDateForApiCall(date) {
            var d = new Date(date);
            return (
                d.getDate() + '.' + (d.getMonth() + 1).toString().padStart(2, "0") + '.' + d.getFullYear()
            );
        },
        fetchPossibilityForVacation(absence) {
            axios
                .get("/api/projectemployeerequirements/checkWithoutEmployee?employee_id=" +
                    absence.employee_id +
                    '&startDate=' +
                    this.formatDateForApiCall(absence.start_at) +
                    '&endDate=' + this.formatDateForApiCall(absence.end_at)
                ).then((resp) => {
                    if (resp.data[0].error !== false) {
                        this.possibilityFaultyWeeks = [];
                        for (const [week, year] of Object.entries(resp.data[0].additional_data.notPossibleWeeks)) {
                            var newLink = [];
                            newLink.href = '/shifts?team=' + this.employee.team_id + '&year=' + year + '&week=' + week + '&simulation=1';
                            newLink.linktext = 'Schichtplan für Woche ' + week;
                            this.possibilityFaultyWeeks.push(newLink);
                        }
                        this.possibilityReport = 'Achtung! Folgende Schichtpläne sind bei Genehmigung dieses Urlaubs nicht ausreichend besetzt!';
                    }
                }).catch((error) => {
                    console.log(error);
                });
        },
        checkPermission(permission) {
            axios
                .get("/api/user-has-permission", {
                    params: {
                        permission: permission
                    }
                })
                .then((resp) => {
                    //console.log("permissionCheck: " , resp);
                    if (resp.data === false) {
                        //console.log("permissionCheck: ", resp.data);
                        if (permission == 'negative-vacation') {
                            this.can_negative_vacation = false;
                        }
                        return;
                    }
                    if (resp.data === true) {
                        //console.log("permissionCheck: " , resp.data);
                        if (permission == 'negative-vacation') {
                            this.can_negative_vacation = true;
                        }
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });
        },
    }
}
</script>

<style lang="scss"></style>
